import React, {
    useEffect,
    useRef,
    useState
} from "react";

import {
    Card,
    Button,
    Select,
    Typography,
    Space,
    Spin,
    Table,
    Tag,
    Divider,
    Row,
    Col,
    Avatar,
    Alert,
    Empty,
    Grid
} from "antd";

import {
    ArrowLeftOutlined,
    BookOutlined,
    TrophyOutlined,
    UserOutlined,
    DownloadOutlined
} from "@ant-design/icons";

import Swal from "sweetalert2";

import api from "../../api/api";

import {
    jsPDF
} from "jspdf";

import html2canvas from "html2canvas";

import testlogo from "./savationChristLogo.png";


const {
    Title,
    Text
}=Typography;


const {
    Option
}=Select;


const {
    useBreakpoint
}=Grid;



const ParentsStudentGrades=({
    selectedChild,
    onBack
})=>{


const screens=useBreakpoint();



const [periods,setPeriods]=useState([]);

const [
    selectedPeriod,
    setSelectedPeriod
]=useState("");

const [
    grades,
    setGrades
]=useState([]);

const [
    loading,
    setLoading
]=useState(false);


const [
    periodLoading,
    setPeriodLoading
]=useState(false);



const reportRef=useRef();



const token=localStorage.getItem(
    "access"
);



/*
=================================
 PROFESSIONAL SCHOOL THEME
=================================
*/

const theme={

primary:"#b45309",

gold:"#d97706",

cream:"#fffbeb",

lightGold:"#fef3c7",

green:"#15803d",

blue:"#1d4ed8",

red:"#b91c1c",

text:"#1f2937",

muted:"#6b7280",

border:"#d6d3d1",

white:"#ffffff",

background:"#fafaf9"

};




/*
=================================
 SCORE GRADING SYSTEM
=================================
*/

const getScoreStyle=(value)=>{

const score=parseFloat(value);


if(isNaN(score)){

return {

background:"#f3f4f6",

color:"#374151",

border:"1px solid #d1d5db"

};

}



if(score >= 70){

return {

background:"#dbeafe",

color:"#1e40af",

border:"1px solid #93c5fd"

};

}



return {

background:"#fee2e2",

color:"#991b1b",

border:"1px solid #fca5a5"

};


};



const getGradeLabel=(value)=>{

const score=parseFloat(value);


if(isNaN(score))
return "N/A";


if(score >= 70)
return "Passed";


return "Needs Improvement";


};




/*
=================================
 FETCH PERIODS
=================================
*/


useEffect(()=>{


const fetchPeriods=async()=>{


if(!token)
return;



try{


setPeriodLoading(true);



const response=await api.get(

"/api/users/periods/",

{

headers:{

Authorization:
`Bearer ${token}`

}

}

);



setPeriods(
response.data
);



}catch(error){


Swal.fire({

icon:"error",

title:"Failed",

text:
"Unable to load academic periods."

});


}

finally{


setPeriodLoading(false);


}



};



fetchPeriods();



},[token]);







const handlePeriodChange=(value)=>{


setSelectedPeriod(value);


setGrades([]);


};







/*
=================================
 FETCH STUDENT GRADES
=================================
*/


const fetchGrades=async()=>{


if(!selectedChild){


Swal.fire({

icon:"warning",

title:"Student Required",

text:
"Please select a student first."

});


return;


}



if(!selectedPeriod)
return;




try{


setLoading(true);


setGrades([]);



const response=await api.get(


"/api/users/linked-student-grades/",


{


headers:{


Authorization:
`Bearer ${token}`


},


params:{


period_id:selectedPeriod,


student_id:selectedChild.id


}


}


);



if(!response.data.length){


Swal.fire({

icon:"info",

title:"No Results",

text:
"Grades have not been published for this period."

});



setGrades([]);



}else{


setGrades(
response.data
);


}




}catch(error){


Swal.fire({

icon:"error",

title:"Error",

text:
"Unable to load student grades."

});


setGrades([]);


}

finally{


setLoading(false);


}



};








/*
=================================
 PDF DOWNLOAD
=================================
*/


const downloadPDF=async()=>{


const element=reportRef.current;



if(!element)
return;



try{


const canvas=
await html2canvas(

element,

{

scale:2,

backgroundColor:"#ffffff",

useCORS:true

}

);



const imageData=
canvas.toDataURL(
"image/png"
);



const pdf=
new jsPDF(
"p",
"mm",
"a4"
);



const pdfWidth=190;



const pdfHeight=
(canvas.height*pdfWidth)/
canvas.width;



pdf.addImage(

imageData,

"PNG",

10,

10,

pdfWidth,

pdfHeight

);



pdf.save(

`${grades[0]?.student_name || "Student"}-Grade-Report.pdf`

);



}catch(error){


Swal.fire({

icon:"error",

title:"PDF Error",

text:
"Unable to generate PDF."

});


}



};





const studentGrade=grades[0];





/*
=================================
 TABLE COLUMNS
 (Used in Part 2)
=================================
*/


const subjectColumns=[];





return(

<div

style={{

minHeight:"100vh",

background:

"linear-gradient(135deg,#fafaf9,#fff7ed)",


padding:

screens.xs

?

"12px 8px"

:

"24px"

}}

>



<Card

bordered={false}

style={{

maxWidth:1250,

margin:"0 auto",

borderRadius:20,

background:"#ffffff",

boxShadow:

"0 15px 40px rgba(0,0,0,.08)"

}}


bodyStyle={{

padding:

screens.xs

?

"14px"

:

"24px"

}}

>



{/* HEADER */}


<div

style={{

display:"flex",

flexDirection:

screens.xs

?

"column"

:

"row",

justifyContent:"space-between",

alignItems:"center",

gap:20

}}

>



<div

style={{

display:"flex",

flexDirection:

screens.xs

?

"column"

:

"row",

alignItems:"center",

gap:16,

textAlign:

screens.xs

?

"center"

:

"left"

}}

>


<Avatar

src={testlogo}

size={
screens.xs
?
80
:
70
}

style={{

border:

`4px solid ${theme.gold}`,

background:"#fff"

}}

/>



<div>


<Title

level={2}

style={{

margin:0,

fontWeight:900,

color:theme.text

}}

>

Student Grade Report

</Title>



<Text

style={{

color:theme.muted,

fontSize:15

}}

>

Academic performance overview

</Text>


</div>


</div>





<Button

icon={<ArrowLeftOutlined/>}

onClick={onBack}

size="large"

style={{

borderRadius:12,

height:44,

fontWeight:700

}}

>

Back

</Button>



</div>




<Divider/>





{/* PERIOD SELECTOR */}


<Card

bordered={false}

style={{

background:

"linear-gradient(135deg,#fffbeb,#fef3c7)",

border:

"1px solid #fde68a",

borderRadius:18,

marginBottom:25

}}


>


<Row

gutter={[20,20]}

align="bottom"

>



<Col xs={24} md={16}>


<Text

strong

style={{

display:"block",

color:"#78350f",

marginBottom:8

}}

>

Select Academic Period

</Text>



<Select

size="large"

style={{

width:"100%"

}}

placeholder="Choose Academic Period"

value={
selectedPeriod || undefined
}

loading={periodLoading}

onChange={handlePeriodChange}

>


{
periods.map(period=>(

<Option

key={period.id}

value={period.id}

>

{period.name}

</Option>

))
}


</Select>



</Col>





<Col xs={24} md={8}>


<Button

type="primary"

block

size="large"

loading={loading}

disabled={!selectedPeriod}

icon={<BookOutlined/>}

onClick={fetchGrades}

style={{

height:46,

borderRadius:12,

fontWeight:800,

background:

"linear-gradient(135deg,#b45309,#d97706)",

border:"none"

}}

>

View Grades

</Button>


</Col>


</Row>


</Card>
{/* LOADING */}

{
loading && (

<div
style={{
textAlign:"center",
padding:"50px 20px"
}}
>

<Spin size="large"/>


<Title
level={5}
style={{
marginTop:15,
color:theme.text
}}
>

Loading Grade Sheet...

</Title>


</div>

)
}





{/* EMPTY STATE */}


{
!loading && !studentGrade && (

<Empty

description={

<Text
style={{
color:theme.muted
}}
>

No grade report available

</Text>

}

/>

)

}





{/* REPORT CONTENT */}


{
!loading && studentGrade && (

<div ref={reportRef}>


{/* ===========================
 SCHOOL HEADER
=========================== */}


<Card

bordered={false}

style={{

background:

"linear-gradient(135deg,#ffffff,#fffbeb)",


borderRadius:18,


border:

"1px solid #fde68a",


marginBottom:20

}}

bodyStyle={{

padding:

screens.xs

?

"18px"

:

"25px"

}}

>



<div

style={{

display:"flex",

flexDirection:

screens.xs

?

"column"

:

"row",

alignItems:"center",

gap:18,

textAlign:

screens.xs

?

"center"

:

"left"

}}

>



<Avatar

src={testlogo}

size={90}

style={{

border:

`4px solid ${theme.gold}`,

background:"#fff"

}}

/>



<div>


<Title

level={3}

style={{

margin:0,

fontWeight:900,

color:"#78350f"

}}

>

Salvation In Christ School System


</Title>



<Text

style={{

display:"block",

marginTop:8,

color:theme.text

}}

>
1st Cowfield Junction, Paynesville City, Monrovia Liberia
</Text>



<Text
style={{
display:"block",
marginTop:5,
color:theme.text
}}
>
Contact: 0886909466 / 0770123025
</Text>

<Text
style={{
display:"block",
marginTop:10,
fontWeight:800,
color:"#92400e"
}}
>
Student Periodic Report - Online Portal
</Text>
<Text
style={{
display:"block",
marginTop:5,
fontSize:12,
color:theme.muted
}}
>
This is an official grade report for this student.
For verification or clarification, contact the school address.
</Text>
</div>
</div>
</Card>

{/* ===========================
 STUDENT INFORMATION
=========================== */}



<Card


title={

<Space>

<UserOutlined
style={{
color:theme.gold
}}
/>


<Text strong>

Student Information

</Text>


</Space>

}


style={{

borderRadius:18,

borderTop:

`4px solid ${theme.gold}`,

marginBottom:20

}}


>


<Row

gutter={[25,20]}

>


<Col xs={24} md={8}>


<Text

type="secondary"

style={{

display:"block",

marginBottom:5

}}

>

Student Name

</Text>


<Text strong>

{studentGrade.student_name}

</Text>


</Col>




<Col xs={24} md={8}>


<Text

type="secondary"

style={{

display:"block",

marginBottom:5

}}

>

Grade Class

</Text>


<Text strong>

{studentGrade.grade_class_name}

</Text>


</Col>





<Col xs={24} md={8}>


<Text

type="secondary"

style={{

display:"block",

marginBottom:5

}}

>

Academic Period

</Text>


<Text strong>

{studentGrade.period_name}

</Text>


</Col>



</Row>


</Card>








{/* ===========================
 SUBJECT PERFORMANCE
=========================== */}



<Card


title={

<Space>

<BookOutlined

style={{

color:theme.gold

}}

/>


<Text strong>

Subject Performance

</Text>


</Space>

}


style={{

borderRadius:18

}}


bodyStyle={{

padding:

screens.xs

?

"12px"

:

"22px"

}}

>




{
screens.xs ? (



<div

style={{

display:"flex",

flexDirection:"column",

gap:12

}}

>


{
studentGrade.student_subjects.map(

(item,index)=>{


const scoreStyle=
getScoreStyle(
item.formatted_final_score
);


return(


<div

key={index}

style={{

display:"flex",

justifyContent:"space-between",

alignItems:"center",

padding:"14px",

borderRadius:12,


background:

index%2===0

?

"#fff7ed"

:

"#ffffff",


border:

`1px solid ${theme.border}`

}}

>


<Space>

<BookOutlined

style={{

color:theme.gold

}}

/>


<Text strong>

{item.subject_name}

</Text>


</Space>





<Tag

style={{

...scoreStyle,

fontWeight:800,

borderRadius:20,

padding:"5px 14px"

}}

>


{item.formatted_final_score}


</Tag>



</div>


)


}

)

}



</div>



):(





<Table


className="grade-table"


columns={[


{


title:"Subject",

dataIndex:"subject_name",

key:"subject_name",


render:text=>(


<Space>


<BookOutlined

style={{

color:theme.gold

}}

/>



<Text strong>

{text}

</Text>


</Space>


)


},





{


title:"Final Score",

dataIndex:"formatted_final_score",

key:"score",

align:"center",


render:value=>{


const style=
getScoreStyle(value);



return(

<Tag

style={{

...style,

fontWeight:800,

fontSize:15,

padding:"6px 18px",

borderRadius:20

}}

>

{value}

</Tag>


)


}


}


]}




dataSource={

studentGrade.student_subjects.map(

(item,index)=>(

{

...item,

key:index

}

)

)

}



pagination={false}



bordered



size="middle"



rowClassName={(record,index)=>

index%2===0

?

"grade-row-even"

:

"grade-row"

}


/>




)

}





</Card>
{/* ===========================
 SUMMARY SECTION
=========================== */}


<Row

gutter={[18,18]}

style={{

marginTop:25

}}

>




{/* AVERAGE SCORE */}


<Col xs={24} md={8}>


<Card

style={{

height:"100%",

borderRadius:18,

textAlign:"center",

borderTop:

`4px solid ${theme.gold}`

}}

>



<TrophyOutlined

style={{

fontSize:34,

color:theme.gold

}}

/>



<Title

level={5}

style={{

margin:"12px 0",

color:theme.text

}}

>

Average Score

</Title>




<Tag

style={{

...

getScoreStyle(
studentGrade.average_score
),


fontSize:18,

fontWeight:900,

padding:"7px 22px",

borderRadius:25

}}

>


{studentGrade.average_score}


</Tag>



<Text

style={{

display:"block",

marginTop:8,

color:theme.muted

}}

>

{
getGradeLabel(
studentGrade.average_score
)
}

</Text>



</Card>



</Col>







{/* CLASS RANK */}



<Col xs={24} md={8}>


<Card

style={{

height:"100%",

borderRadius:18,

textAlign:"center",

borderTop:

"4px solid #2563eb"

}}

>



<TrophyOutlined

style={{

fontSize:34,

color:"#2563eb"

}}

/>



<Title

level={5}

style={{

margin:"12px 0",

color:theme.text

}}

>

Class Rank

</Title>





<Tag

style={{

background:"#dbeafe",

color:"#1e40af",

border:"1px solid #93c5fd",

fontSize:18,

fontWeight:900,

padding:"7px 22px",

borderRadius:25

}}

>


{studentGrade.rank}


</Tag>



</Card>


</Col>







{/* SUBJECT COUNT */}



<Col xs={24} md={8}>


<Card

style={{

height:"100%",

borderRadius:18,

textAlign:"center",

borderTop:

"4px solid #15803d"

}}

>



<BookOutlined

style={{

fontSize:34,

color:"#15803d"

}}

/>



<Title

level={5}

style={{

margin:"12px 0",

color:theme.text

}}

>

Subjects

</Title>




<Tag

style={{

background:"#dcfce7",

color:"#166534",

border:"1px solid #86efac",

fontSize:18,

fontWeight:900,

padding:"7px 22px",

borderRadius:25

}}

>


{
studentGrade.student_subjects.length
}

Courses


</Tag>



</Card>



</Col>



</Row>









{/* ===========================
 TEACHER REMARK
=========================== */}



<Card


title={

<Text strong>

Teacher Remark

</Text>

}



style={{

marginTop:25,

borderRadius:18,

borderTop:

`4px solid ${theme.gold}`

}}



>



<Alert


message={

studentGrade.remark ||

"No remark provided."

}



type="info"



showIcon



/>


</Card>









{/* ===========================
 DOWNLOAD PDF
=========================== */}



<div

style={{

display:"flex",

justifyContent:"center",

marginTop:30,

paddingBottom:10

}}

>


<Button


type="primary"



size="large"



icon={<DownloadOutlined/>}



onClick={downloadPDF}



style={{

height:50,

padding:"0 40px",

borderRadius:30,

fontWeight:900,

fontSize:16,


background:

"linear-gradient(135deg,#b45309,#d97706)",


border:"none",


boxShadow:

"0 8px 20px rgba(180,83,9,.35)"

}}



>


Download Grade PDF


</Button>



</div>




</div>


)


}




</Card>


</div>


);


};



export default ParentsStudentGrades;
